import React from "react";
import halfPage from "../assets/images/bg.svg";
import { useSelector } from "react-redux";
import "./style.css";
function LeftBarDesign(props) {
  const { gradientColor } = useSelector((state) => state.theme);
  return (
    <div
      className="container-fluid"
      style={{ fontFamily: "'Montserrat', sans-serif" }}
    >
      <div
        className="row"
        style={{ padding: "0px" }}
      >
        <div className="col-md-6 p-5 design8-background">
          <div className="d-sm-block d-md-none d-lg-none mt-5">
            {props.innerDesign}
          </div>
        </div>
        <div className="d-sm-none d-none d-md-block d-lg-block design8-dataBox mt-5 py-2">
          {props.innerDesign}
        </div>
        <div
          className="col-md-6 d-sm-none d-none d-md-block d-lg-block"
          style={{
            background: `linear-gradient(${gradientColor.color1}, ${gradientColor.color2})`,
            minHeight: "100vh",
            overflow: "hidden",
            padding: "0px",
          }}
        >
          <img
            src={halfPage}
            className="w-100"
            style={{ objectFit: "cover", height: "100%" }}
            alt=""
          />
        </div>
      </div>
    </div>
  );
}
export default LeftBarDesign;
